import './pdp.css';
import 'swiper/css';

import { Swiper, Pagination } from 'swiper';

export default () => {
  class MainProduct extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.product-tab-item')
      this.tabContents = this.querySelectorAll('.pdp__tabs__body__item');
      this.customDots = this.querySelectorAll('.pdp__media__dots button');
      this.mobileSlider = this.querySelector(".mobile-gallery");
      this.pdpTopSection = document.querySelector('.pdp__top_section');
      this.isHidden = false;
      this.careBtn = this.querySelectorAll('.client-care');
      this.carePopup = this.querySelectorAll('.customer-care-popup');
      this.careClose = this.querySelectorAll('.customer-care-popup__close');
      this.stickyBar = this.querySelector('.sticky-bar');
      this.stickyBarOffset = this.stickyBar?.offsetTop;
      this.stickyClass = "is-sticky";
      this.swiper = null;
      this.variantImageMap = {};
      const selectElem = document.querySelectorAll('.product-form__input--dropdown .select__select');

      if(selectElem.length === 0) {
        document.querySelector('.sticky-add-to-cart-link')?.classList.add('hidden')
        document.querySelector('.sticky-form')?.classList.remove('hidden')
        if (document.querySelector('.sticky-form')) {
          document.querySelector('.sticky-form').style.display = 'inline-block'
        }
      }

      if (this.tabs.length > 0) {
        this.activateTab(this.tabs[0], this.tabs, this.tabContents);
      }

      if (this.customDots.length > 0) {
        this.customDots[0].classList.add('active-dot');
        this.customDots[0].setAttribute('aria-current', 'true');
      }

      // Initialize variant-image mapping
      this.initVariantImageMapping();
      this.initEventListeners();
    }

    initVariantImageMapping() {
      // Get the variants data from the JSON script
      const variantSelectsElement = document.querySelector('variant-selects');
      if (!variantSelectsElement) return;

      const variantsJson = variantSelectsElement.querySelector('script[type="application/json"]');
      if (!variantsJson) return;

      // Parse the variants data
      try {
        const variants = JSON.parse(variantsJson.textContent);

        // Create a mapping between variant IDs and their featured media IDs
        variants.forEach(variant => {
          if (variant.featured_media && variant.featured_media.id) {
            this.variantImageMap[variant.id] = variant.featured_media.id;
          }
        });
      } catch (e) {
        // eslint-disable-next-line
        console.error('Error parsing variants JSON:', e);
      }
    }

    initEventListeners() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.activateTab(tab, this.tabs, this.tabContents));
      });

      this.customDots.forEach(dot => {
        dot.addEventListener('click', () => this.handleDotClick(dot));
      });

      window.addEventListener('scroll', () => {
        this.handleScroll();
        this.handleScrollLimits();
        // this.showStickyBar();
      });

      this.careBtn.forEach(btn => {
        btn.addEventListener('click', () => this.showCarePopup(btn));
      });

      this.careClose.forEach(btn => {
        btn.addEventListener('click', () => {
          this.carePopup.forEach(item=> {
            item.classList.add('hidden')
          })
        });
      });

      // Listen for variant change events
      this.setupVariantChangeListeners();
    }

    setupVariantChangeListeners() {
      // Listen for changes on the select elements
      const variantSelects = document.getElementById('product-variants');
      if (!variantSelects) return;

      const selectElements = variantSelects.querySelectorAll('select.select__select');
      selectElements.forEach(select => {
        select.addEventListener('change', () => this.handleVariantChange());
      });

      // Also watch for custom dropdown clicks if they're used
      const customDropdowns = variantSelects.querySelectorAll('custom-dropdown');
      customDropdowns.forEach(dropdown => {
        const dropdownItems = dropdown.querySelectorAll('.dropdown-menu li a');
        dropdownItems.forEach(item => {
          item.addEventListener('click', () => {
            setTimeout(() => this.handleVariantChange(), 100);
          });
        });
      });

      // Listen for URL changes which may indicate variant changes
      window.addEventListener('popstate', () => this.handleVariantChange());

      // Listen for variant-change events that Shopify might trigger
      document.addEventListener('variant:change', () => {
        this.handleVariantChange();
      });

      // Initialize by checking if there's a default variant selected
      setTimeout(() => this.handleVariantChange(), 500);
    }

    handleVariantChange() {
      // Get the current selected variant ID
      const currentVariantId = this.getCurrentVariantId();
      if (currentVariantId) {
        this.scrollToVariantImage(currentVariantId);
      }
    }

    getCurrentVariantId() {
      // Method 1: For standard Shopify themes that update the URL or form
      const variantInput = document.querySelector('input[name="id"][data-product-selected-variant]');
      if (variantInput) {
        return variantInput.value;
      }

      // Method 2: Check the URL for variant ID
      const url = new URL(window.location.href);
      const variantIdFromUrl = url.searchParams.get('variant');
      if (variantIdFromUrl) {
        return variantIdFromUrl;
      }

      // Method 3: If your theme uses a custom variant selector
      const variantSelectsElement = document.querySelector('variant-selects');
      if (variantSelectsElement) {
        const variantsJson = variantSelectsElement.querySelector('script[type="application/json"]');
        if (variantsJson) {
          try {
            const variants = JSON.parse(variantsJson.textContent);
            const selectElements = document.querySelectorAll('select.select__select');
            const selectedOptions = [];

            selectElements.forEach(select => {
              if (select.value) {
                selectedOptions.push(select.value);
              }
            });

            if (selectedOptions.length > 0) {
              // Find the variant that matches all selected options
              const selectedVariant = variants.find(variant =>
                variant.options.every((option, index) =>
                  selectedOptions[index] ? option === selectedOptions[index] : true));

              if (selectedVariant) {
                return selectedVariant.id;
              }
            }

            // If no match found, return the first variant as default
            if (variants.length > 0) {
              return variants[0].id;
            }
          } catch (e) {
            // eslint-disable-next-line
            console.error('Error finding variant:', e);
          }
        }
      }

      return null;
    }

    scrollToVariantImage(variantId) {
      const mediaId = this.variantImageMap[variantId];

      if (!mediaId) return; // No image associated with this variant

      // For desktop gallery
      const targetImage = document.getElementById(`product-item-${mediaId}`);

      if (targetImage) {
        // Scroll the image into view
        targetImage.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });

        // Highlight the image
        this.highlightImage(targetImage);

        // Update the active dot
        this.updateActiveDot(targetImage.id);
      }

      // For mobile swiper
      if (this.swiper) {
        const slides = this.mobileSlider.querySelectorAll('.swiper-slide');

        // Find the slide with matching data-media-id attribute
        let slideIndex = -1;
        slides.forEach((slide, index) => {
          const slideMediaId = slide.getAttribute('data-media-id');
          // eslint-disable-next-line
          if (slideMediaId && slideMediaId == mediaId) {
            slideIndex = index;
          }
        });

        // If we found a matching slide, go to it
        if (slideIndex !== -1) {
          this.swiper.slideTo(slideIndex);
        }
      }
    }

    highlightImage(targetImage) {
      // Add highlighted class to the target image
      targetImage.classList.add('variant-selected');

      // Remove highlight from other images
      const allImages = document.querySelectorAll('.pdp__media__item');
      allImages.forEach(item => {
        if (item !== targetImage) {
          item.classList.remove('variant-selected');
        }
      });
    }

    updateActiveDot(imageId) {
      this.customDots.forEach(dot => {
        if (dot.getAttribute('data-id') === imageId) {
          dot.classList.add('active-dot');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('active-dot');
          dot.setAttribute('aria-current', 'false');
        }
      });
    }

    showCarePopup(elem) {
      elem.nextElementSibling.classList.toggle('hidden');
    }

    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }

    handleDotClick(clickedDot) {
      this.customDots.forEach(dot => dot.classList.remove('active-dot'));
      clickedDot.classList.add('active-dot');
      clickedDot.setAttribute('aria-current', 'true');
      this.scrollTo(clickedDot.getAttribute('data-id'));
    }

    handleScroll() {
      const connectedImages = document.querySelectorAll('.pdp__media__item');
      let activeDotId = null;

      connectedImages.forEach(connectedImage => {
        if ((window.scrollY + window.innerHeight - 100) >= connectedImage.offsetTop) {
          activeDotId = connectedImage.getAttribute('id');
        }
      });

      // Ensure the first dot is active when near the top
      if (window.scrollY < 100 && this.customDots.length > 0) {
        activeDotId = this.customDots[0].getAttribute('data-id');
      }

      if (activeDotId) {
        this.customDots.forEach(dot => {
          const dotId = dot.getAttribute('data-id');
          if (dotId === activeDotId) {
            dot.classList.add('active-dot');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('active-dot');
            dot.setAttribute('aria-current', 'false');
          }
        });
      }
    }

    pdpGallery() {
      if (this.mobileSlider) {
        // eslint-disable-next-line
        this.swiper = new Swiper(this.mobileSlider, {
          direction: 'horizontal',
          slidesPerView: 1,
          spaceBetween: 30,
          modules: [Pagination],
          pagination: {
            el: '.gallery-swiper-pagination',
            clickable: true
          },
          on: {
            init: () => {
              // Initialize with current variant if available
              setTimeout(() => this.handleVariantChange(), 500);
            }
          }
        });
      }
    }

    showStickyBar() {
      if (!this.stickyBar) return;

      const { scrollY } = window;

      if (scrollY > 50) {
        this.stickyBar.classList.add(this.stickyClass);

        const scrollToButton = this.stickyBar.querySelector('a, button');
        if (scrollToButton) {
          scrollToButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.scrollToWithOffset('pdp-scroll');
          });
        }
      } else {
        this.stickyBar.classList.remove(this.stickyClass);
      }
    }

    scrollToWithOffset(id) {
      const element = document.getElementById(id);
      if (element) {
        const stickyBarHeight = this.stickyBar ? this.stickyBar.offsetHeight : 0;
        const offsetTop = element.getBoundingClientRect().top + window.scrollY - stickyBarHeight;

        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }

    activateTab(tab, tabs, tabContents) {
      tabs.forEach(t => t.classList.remove('is-active'));
      tabs.forEach(t => t.removeAttribute('aria-selected'));
      tabContents.forEach(c => c.classList.remove('is-active'));

      tab.classList.add('is-active');
      const handle = tab.getAttribute('data-handle');
      tab.toggleAttribute('aria-selected', 'true')
      const content = document.getElementById(`tab-content-${handle}`);
      if (content) {
        content.classList.add('is-active');
      }
    }

    handleScrollLimits() {
      if (!this.pdpTopSection) return;

      const pdpTopSectionRect = this.pdpTopSection.getBoundingClientRect();
      const isScrolledPast = pdpTopSectionRect.bottom - 700 < 0;

      if (isScrolledPast && !this.isHidden) {
        this.customDots.forEach(dot => {
          // eslint-disable-next-line
          dot.style.visibility = 'hidden';
        });
        this.isHidden = true;
      } else if (!isScrolledPast && this.isHidden) {
        this.customDots.forEach(dot => {
          // eslint-disable-next-line
          dot.style.visibility = 'visible';
        });
        this.isHidden = false;
      }
    }

    connectedCallback() {
      this.pdpGallery();
    }

    disconnectedCallback() {
      this.tabs.forEach(tab => {
        tab.removeEventListener('click', () => this.activateTab(tab, this.tabs, this.tabContents));
      });

      this.customDots.forEach(dot => {
        dot.removeEventListener('click', () => this.handleDotClick(dot));
      });

      window.removeEventListener('scroll', () => {
        this.handleScroll();
        this.handleScrollLimits();
        this.showStickyBar();
      });

      // Destroy swiper instance if it exists
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }

  const init = () => {
    if (!customElements.get("main-product")) {
      customElements.define('main-product', MainProduct);
    }
  };

  init();
};
